// Treatment status (PI). Reads matter.workspace.treatment (loose shape).
// Falls back to matter.workspace.treatmentStatus string for legacy data.

import { EMPTY } from "../../chrome/SepList";
import { pick, type WidgetProps } from "./types";
import { WidgetCard } from "./WidgetCard";

interface TreatmentShape {
  status?: string;
  provider?: string;
  visits?: number;
  lastVisit?: string;
  estimatedTotal?: number;
}

export function TreatmentStatusWidget({ config, matter }: WidgetProps) {
  const t = pick<TreatmentShape>(matter.workspace, "treatment");
  const fallback = pick<string>(matter.workspace, "treatmentStatus");
  const title = config.title ?? "Treatment status";

  if (!t && !fallback) {
    return (
      <WidgetCard title={title}>
        <div style={{ fontSize: 12.5, color: "var(--muted)" }}>No treatment data tracked.</div>
      </WidgetCard>
    );
  }

  return (
    <WidgetCard title={title} sub={t?.status ?? fallback ?? EMPTY}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 10,
          fontSize: 12,
        }}
      >
        <Cell label="Provider" value={t?.provider ?? EMPTY} />
        <Cell label="Visits" value={t?.visits != null ? String(t.visits) : EMPTY} />
        <Cell label="Last visit" value={t?.lastVisit ?? EMPTY} />
        <Cell
          label="Est. total"
          value={t?.estimatedTotal != null ? `$${t.estimatedTotal.toLocaleString()}` : EMPTY}
        />
      </div>
    </WidgetCard>
  );
}

function Cell({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <div
        style={{
          fontSize: 9.5,
          fontWeight: 700,
          textTransform: "uppercase",
          letterSpacing: "0.08em",
          color: "var(--muted)",
        }}
      >
        {label}
      </div>
      <div
        style={{
          fontSize: 12.5,
          fontWeight: 600,
          fontVariantNumeric: "tabular-nums",
          color: value === EMPTY ? "var(--muted)" : "var(--ink)",
        }}
      >
        {value}
      </div>
    </div>
  );
}
